module.exports = __webpack_public_path__ + "img/image3.68d0ff5d.jpg";